import { createTheme } from "@mui/material/styles";
import { green, grey, red } from "@mui/material/colors";

export const applicationTheme = createTheme({
  cssVariables: { colorSchemeSelector: "class" },
  colorSchemes: {
    light: {
      palette: {
        primary: { light: "#E3F2FD", main: "#1565C0", dark: "#0D47A1", contrastText: "#fff" },
        secondary: { light: "#FFF8E1", main: "#FF8F00", dark: "#E65100", contrastText: "#fff" },
        success: { main: green[600] },
        error: { main: red[600] },
        background: { default: grey[50], paper: "#fff" },
      },
    },
    dark: {
      palette: {
        primary: { light: "#BBDEFB", main: "#64B5F6", dark: "#1E88E5", contrastText: "#0B1F33" },
        secondary: { light: "#FFE0B2", main: "#FFB74D", dark: "#FB8C00", contrastText: "#1F1300" },
        success: { main: green[400] },
        error: { main: red[400] },
      },
    },
  },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 960, lg: 1280, xl: 1500 },
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: ["Open Sans", "sans-serif"].join(","),
    fontWeightMedium: 600,
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        rounded: { borderRadius: 12 },
      },
    },
    MuiCard: {
      defaultProps: { variant: "outlined" },
    },
  },
});
